import styled from 'styled-components';

import { colors } from '@style-guide/config';

const ErrorMessage = styled.p`
  color: ${colors.red};
  font-style: italic;
  margin-top: 4px;
`;

ErrorMessage.displayName = 'ErrorMessage';

export default ErrorMessage;
